// ─────────────────────────────────────────────────────────────────────────
// SINGLE SOURCE OF TRUTH for money formatting (Indian Rupee).
// Use these everywhere a price/amount is shown so the ₹ style is defined once
// (add decimals / change locale here and every screen follows).
//
//   formatINR(1299)  -> "₹1,299"   (symbol included)
//   formatAmount(1299) -> "1,299"  (no symbol — when the ₹ is rendered separately)
// ─────────────────────────────────────────────────────────────────────────
export const formatAmount = (n) => Number(n || 0).toLocaleString("en-IN");
export const formatINR    = (n) => "₹" + formatAmount(n);
